module.exports = __webpack_public_path__ + "static/img/c3.be865e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/c3.png
// module id = 0ith
// module chunks = 0